import { callAPI } from './api.service';
import { Toast } from '../components/Common/Toast';
import { setRedirectURL } from '../store/userSlice';
import { AppDispatch } from '../store/store';
import { cleanObject } from '../helper/helper';
import { CurrencyEnum } from '../interfaces/plan.interface';

export const createSubscriptionSessionAndRedirect = async (
  planId: string,
  userEmail: string,
  dispatch: AppDispatch,
  selfRedirect: boolean = false,
  index: number = -1,
  isFinishStory: boolean = false,
  currency?: CurrencyEnum,
  errorCallback?: () => void,
  setSubscriptionLoader?: (index: number) => void
) => {
  if (!userEmail || !planId) {
    Toast('User or plan not found', true);
    return;
  }
  setSubscriptionLoader && setSubscriptionLoader(index);
  try {
    const requestBody: any = {
      planId: planId,
      email: userEmail,
      isFinishStory: isFinishStory
    };

    // Add currency to request body if provided
    if (currency) {
      requestBody.currency = currency;
    }

    const response = await callAPI(`user/subscription/create-checkout-session`, requestBody);

    if (response.url) {
      if (selfRedirect) {
        dispatch(setRedirectURL(response.url));
      } else {
        window.open(response.url);
      }
    } else {
      console.error('No URL in response:', response);
      throw new Error('No URL in response');
    }
  } catch (error) {
    Toast('Error generate stripe subscription payment', true);
    errorCallback && errorCallback();
  } finally {
    setSubscriptionLoader && setSubscriptionLoader(-1);
  }
};

export const createInvitedUserSubscriptionSessionAndRedirect = async (
  token: string,
  userEmail: string,
  dispatch: AppDispatch,
  selfRedirect: boolean = false,
  errorCallback?: () => void
) => {
  if (!userEmail || !token) {
    return;
  }
  try {
    const response = await callAPI(`user/subscription/create-invite-checkout-session`, {
      email: userEmail
    }, 'POST', cleanObject({
      'Content-Type': 'application/json',
      'invite_access_token': token
    }));

    if (response.url) {
      if (selfRedirect) {
        dispatch(setRedirectURL(response.url));
      } else {
        window.open(response.url);
      }
    } else {
      console.error('No URL in response:', response);
      dispatch(setRedirectURL('/'));
    }
  } catch (error) {
    Toast('Error generate stripe subscription payment', true);
    errorCallback && errorCallback();
  }
};
